import React from 'react';
import Project from './Project';
import projectData from '../project-data.js';

const ProjectList = () => (
		<div className="projects">
			<h1>My Projects</h1>
			<div className="list-of-projects">
			{
				Object.keys(projectData)
				.map(key => <Project key={key} details={projectData[key]} />)
			}
			</div>
		</div>
		)
export default ProjectList;


/** WEBPACK FOOTER **
 ** ./src/components/ProjectList.js
 **/